import { Component } from '@angular/core';

@Component({
    selector: 'rwidget-related-cards-list-header',
    templateUrl: './related-cards-list-header.component.html',
    styleUrls: ['./related-cards-list-header.component.scss'],
})
export class RelatedCardsListHeaderComponent {}
